import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

// Base API URL for blogs
const API_URL = BaseUrl.baseUrl + 'blog';

// Function to get token from localStorage
const getToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.token : null;
};

// Function to handle errors
const handleError = (error) => {
    throw new Error(error.response ? error.response.data.message : 'An error occurred');
};

// Create a new blog
const createBlog = async (web, blogDTO) => {
    const token = getToken();
    try {
        const response = await axios.post(`${API_URL}?web=${web}`, blogDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get a blog by ID
const getBlogById = async (web, blog) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}?web=${web}&blog=${blog}`,{
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get paginated blogs for a website
const getPaginatedBlogs = async (page = 0, size = 10, web) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/paginated?page=${page}&size=${size}&web=${web}`,{
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Update a blog
const updateBlog = async (web, blog, blogDTO) => {
    const token = getToken();
    try {
        const response = await axios.put(`${API_URL}?web=${web}&blog=${blog}`, blogDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Delete a blog
const deleteBlog = async (web, blog) => {
    const token = getToken();
    try {
        await axios.delete(`${API_URL}?web=${web}&blog=${blog}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Approve a blog
const approveBlog = async (web, blog) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/approved?web=${web}&blog=${blog}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Reject a blog
const rejectBlog = async (web, blog) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/reject?web=${web}&blog=${blog}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Upload a image for blog
const uploadImage = async (formData) => {
    const token = getToken();
    try {
        const response = await axios.post(`${API_URL}/upload-image`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Remove a profile picture for a user
const removeImage = async (imageName) => {
    const token = getToken();
    try {
        await axios.delete(`${API_URL}/remove-image?imageName=${imageName}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// set schema
const setSchema = async (schemaDTO) => {
    const token = getToken();
    try {
        const response = await axios.patch(API_URL+'/set-schema', schemaDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// set published date
const changePublishedDate = async (web, blog, date) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/set-published?web=${web}&blog=${blog}&date=${date}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// set published date
const setCoverImageAlt = async (web, blog, alt) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/set-alt?web=${web}&blog=${blog}&alt=${alt}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// set published date
const setSlug = async (web, blog, slug) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/set-formatted-title?web=${web}&blog=${blog}&slug=${slug}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Export all methods as BlogService
const BlogService = {
    createBlog,
    getBlogById,
    getPaginatedBlogs,
    updateBlog,
    deleteBlog,
    approveBlog,
    rejectBlog,
    uploadImage,
    removeImage,
    setSchema,
    changePublishedDate,
    setCoverImageAlt,
    setSlug,
};

export default BlogService;
